module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Marko_480x480.eeb00a1d.mp4";